import { AfterViewInit, OnDestroy, OnInit } from "@angular/core";
import { BehaviorSubject } from "rxjs";

export abstract class FieldStateService implements OnInit, AfterViewInit, OnDestroy {
    abstract stateObservable$: BehaviorSubject<any>;
    abstract dispatchFieldUpdate(payload, index?): void;
    abstract dispatchFieldLoad(payload): void;

    public dispatchFieldTouched(): void {
        const newState = this.newState({});
        newState.touched = true;
        this.stateObservable$.next(newState);
    }

    public dispatchFieldError(errorMessage): void {
        const newState = this.newState({});
        newState.errorMessage = errorMessage;
        this.stateObservable$.next(newState);
    }

    public dispatchListLoad(payload, ...args): void {
        throw new Error("this.dispatchListLoad is Not Implemented!");
    };

    public dispatchAddValueToStaging(payload): void {
        throw new Error("this.dispatchAddValueToStaging is Not Implemented!");
    };
    public dispatchRemoveValueFromStaging(payload): void {
        throw new Error("this.dispatchRemoveValueFromStaging is Not Implemented!");
    };

    public dispatchStateReset(initialState): void {
        this.stateObservable$.next(this.newState(initialState));
    }

    public newState(state) {
        return Object.assign({}, this.stateObservable$.getValue(), state);
    }

    public transformAndDispatchFieldUpdate(value): void { }

    public ngOnInit() { }
    public ngAfterViewInit() { }
    public ngOnDestroy() { }
}
